import { render, staticRenderFns } from "./InstagramVerify.vue?vue&type=template&id=1a77ab98&scoped=true&"
import script from "./InstagramVerify.vue?vue&type=script&lang=js&"
export * from "./InstagramVerify.vue?vue&type=script&lang=js&"
import style0 from "./InstagramVerify.vue?vue&type=style&index=0&id=1a77ab98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77ab98",
  null
  
)

/* custom blocks */
import block0 from "./InstagramVerify.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports